import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
}));
